'use strict';
import { cn_add, cn_ceiling_type, cn_number_input, cn_pastille, CN_SPACE_LABEL_WIDTH, cn_type_pastille } from '..';
//***********************************************************************************
//***********************************************************************************
//**** cn_svg_tool_facing  : Facing Manager
//***********************************************************************************
//***********************************************************************************
import { cn_camera } from './cn_camera';
import { cn_svg_map } from './cn_svg_map';
import { cn_svg_tool_creation } from './cn_svg_tool_creation';
import { cn_notification_input } from './cn_inputs';

/**
 */
export class cn_svg_tool_ceiling extends cn_svg_tool_creation {
    //***********************************************************************************
    /**
     * Constructor
     * @param {cn_svg_map} svg_map
     */
    constructor(svg_map) {
        super(svg_map);
        this._mouseover = null;
        this._mouseover_space = null;
        this._selection = null;
        this._pastilles = [];
        this.selected_element = null;
        this.mouseover_element = null;
        this.mouseover_storey = null;
        this.mouseover_side = null;
        this.mouseover_facing = null;
        this.mouseover_object = null;
        this.mouseover_siblings = [];
        this.selected_siblings = [];
        this.facing_pastilles = [];
        this._facing_lineic_facing = null;
        this._facing_lineics = [];
        this._facing_lineics_date = 0;
    }


    //***********************************************************************************
    /**
     * Open tool
     */
    open_tool() {
        this._update_pastilles();
    }

    //***********************************************************************************
    /**
     * Close tool
     */
    close_tool() {
    }

    _update_pastilles() {
        this._pastilles = [];
        this._scene.spaces.filter(space => !space.outside && space.is_roof(this._scene.storey)).forEach(space => {
            const space_center = cn_add(space.center, space.label_position)

            //*** Type pastille */
            const type_pastille = new cn_type_pastille([space], 'ceiling_type', () => this._building.get_ceiling_types(), 'Type de faux-plafond', this._map);
            type_pastille.position = space_center;
            type_pastille.title = 'Modifier le type de faux-plafond';
            type_pastille.on("type_changed", () => this._update_pastilles());
            type_pastille.null_element_type = new cn_ceiling_type(this._building);
            type_pastille.offset = [15 - CN_SPACE_LABEL_WIDTH[0] / 2, 60];
            type_pastille["space"] = space;
            this._pastilles.push(type_pastille);

            if (space.ceiling_type) {
                const height_pastille = new cn_pastille(space_center, 'arrow_collapse_up.svg');
                height_pastille.offset = [type_pastille.offset[0] + 40, type_pastille.offset[1]];
                height_pastille.rectangle = [30, 30];
                height_pastille.svg_class = 'pastille_background white';
                height_pastille.title = 'Hauteur sous plafond';
                height_pastille["space"] = space;
                this._pastilles.push(height_pastille);

                height_pastille.clicked = () => {
                    const input = new cn_number_input('Hauteur sous plafond', space.ceiling_height, 'm', 2, 1);
                    input.callback = () => {
                        this.push_transaction('Hauteur sous plafond');
                        this.push_item_set(space, 'ceiling_height');
                        space.ceiling_height = input.value;
                    };
                    this._map.call('number_input', input);
                };

                const heated_pastille = new cn_pastille(space_center, (space.regulated_ceiling) ? 'thermometer.svg' : 'thermometer-off.svg');
                this._pastilles.push(heated_pastille);
                heated_pastille.offset = [height_pastille.offset[0] + 40, height_pastille.offset[1]];
                heated_pastille.rectangle = [30, 30];
                heated_pastille.svg_class = 'pastille_background white';
                heated_pastille.title = 'Plenum régulé / non régulé';
                this._pastilles.push(heated_pastille);

                heated_pastille.clicked = () => {
                    this.push_transaction('Hauteur sous plafond');
                    this.push_item_set(space, 'regulated_ceiling');
                    space.regulated_ceiling = !space.regulated_ceiling;
                    heated_pastille.label = (space.regulated_ceiling) ? 'thermometer.svg' : 'thermometer-off.svg';

                    let msg = "";
                    if (space.regulated_ceiling)
                        msg = "Le volume au-dessus du faux-plafond est désormais intégré au volume thermique de la pièce.";
                    else
                        msg = "Le volume au-dessus du faux-plafond est désormais considéré comme un espace tampon.";
                    let input = new cn_notification_input(msg);
                    this._map.call('notification_input', input);
                };
            }
        });
    }

    //***********************************************************************************
    /**
     * SVG rendering
     * @param {cn_camera} camera
     * @returns {string} svg rendered
     */
    // @ts-ignore
    draw(camera) {
        let html = '';

        if (this._mouseover_space)
            html += this._mouseover_space.draw(camera, ["mouseover"]);

        this._pastilles.forEach(pastille => html += pastille.draw(camera));

        html += super.draw(camera);
        return html;
    }

    _select_element(element, position) {
        if (this.selected_element == element) return;
        this.selected_element = element;

        this._pastilles = [];
        if (this.selected_element) {
            //*** ceiling pastille */

        }
    }

    //***********************************************************************************
    /**
     * click
     * @returns {boolean}
     */
    click(ev) {
        if (super.click(ev)) return true;
        if (this._mouseover)
            this._mouseover.clicked();
        return true;
    }

    /**
     * move
     *
     * @param {object} ev
     * @returns {boolean}
     */
    move(ev) {
        this._mouseover = null;
        this._mouseover_space = null;
        this.clear_move();

        this._pastilles.forEach(pastille => {
            pastille.mouseover = pastille.contains(ev.mouse_world, ev.camera);
            if (pastille.mouseover) {
                this._mouseover = pastille;
                this._mouseover_space = pastille["space"];
                ev.title = pastille.title;
            }
        });

        if (this._mouseover)
            return true;

        this._mouseover_space = this._scene.find_space(ev.mouse_world);
        if (this._mouseover_space) {
            const pst = this._pastilles.find(p => p["space"] == this._mouseover_space);
            if (pst) {
                this._mouseover = pst;
                pst.mouseover = true;
                return true;
            }
            this._mouseover_space = null;
        }
        if (super.move(ev)) return true;

        return true;
    }

    /**
     * grab
     *
     * @param {object} ev
     * @returns {boolean}
     */
    grab(ev) {
        if (super.grab(ev)) return true;
        this._terminate_edition();

        return false;
    }

    drag(ev) {
        if (super.drag(ev)) return true;
        return false;
    }

    create(facing) {
        this.push_transaction('Création d\'un revêtement');
        this.push_item_set(this._building, 'facing_types');
        this._building.facing_types.push(facing);
    }

    delete(facing) {
        const facing_index = this._building.facing_types.findIndex(f => f.ID === facing.ID);
        if (facing_index >= 0) {
            this.push_transaction('Suppression d\'un revêtement');
            this.push_item_set(this._building, 'facing_types');
            if (facing.support === 'wall' || facing.support === 'facade') {
                this._building.storeys.forEach(storey => {
                    storey.scene.walls.flatMap(wall => wall.space_segments).filter(wss => wss.facing && wss.facing.ID === facing.ID).forEach(wss => {
                        this.push_item_set(wss, 'facing');
                        wss.facing = null;
                    })
                });
            } else if (facing.support === 'ceiling' || facing.support === 'floor') {
                this._building.storeys.forEach(storey => {
                    storey.scene.spaces.filter(space => space.facings.some(f => f && f.ID === facing.ID)).forEach(space => {
                        this.push_item_set(space, 'facings');
                        if (space.facings[0] && space.facings[0].ID === facing.ID) {
                            space.facings[0] = null;
                        } else if (space.facings[1] && space.facings[1].ID === facing.ID) {
                            space.facings[1] = null;
                        }
                    })
                });
            } else if (facing.support === 'exterior') {
                if (this._building.exterior.scene.spaces) {
                    this._building.exterior.scene.spaces.filter(space => space.facings[0] && space.facings[0].ID === facing.ID).forEach(space => {
                        this.push_item_set(space, 'facings');
                        space.facings[0] = null;
                    })
                }
            } else if (facing.support === 'exterior') {
                if (this._building.exterior.scene.spaces) {
                    this._building.exterior.scene.spaces.filter(space => space.facings[0] && space.facings[0].ID === facing.ID).forEach(space => {
                        this.push_item_set(space, 'facings');
                        space.facings[0] = null;
                    })
                }
            } else if (facing.support === 'other') {
                this._building.storeys.forEach(st => {
                    [
                        ...st.scene.stairs,
                        ...st.scene.object_instances,
                        ...st.scene.beams,
                        ...st.scene.columns
                    ].filter(elt => elt.facing && elt.facing.ID === facing.ID).forEach(elt => {
                        this.push_item_set(elt, 'facing');
                        elt.facing = null;
                    });
                    st.scene.walls.flatMap(w => w.openings).filter(o => o.facings && o.facings.length && o.facings.some(f => f && f.ID === facing.ID)).forEach(opening => {
                        this.push_item_set(opening, 'facings')
                        opening.facings.forEach(f => {
                            if (f && f.ID === facing.ID) {
                                f = null;
                            }
                        })
                    });
                })

            }
            this._building.facing_trimmings.filter(ft => ft.facing && ft.facing.ID === facing.ID).forEach(ft => {
                this.push_item_set(ft, 'facing');
                ft.facing = null;
            })
            this._building.facing_types.splice(facing_index, 1);
        }
    }

    modify(facing) {
        const facing_index = this._building.facing_types.findIndex(f => f.ID === facing.ID);
        this.push_transaction('Modification d\'un revêtement');
        this.push_item_set(this._building.facing_types[facing_index], ['color', 'texture', 'layers', 'name']);
        Object.assign(this._building.facing_types[facing_index], facing);
    }
}

